export let highImportanceMenuText = "YOE5qe";
export default {highImportanceMenuText};